import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import MessagePropType from '../definitions/MessagePropType';

import FullScreenTakeover, { DISPLAY_MODES } from './FullScreenTakeover';
import ErrorModalDisplay from './ErrorModalDisplay';


function ErrorModal({
    isOpen = true,

    onClose,
    onAccept,

    title,
    description,
    acceptText,

    displayMode = DISPLAY_MODES.LIGHTBOX,
}) {
    return (
        <FullScreenTakeover
            isOpen={isOpen}
            onClose={onClose}

            showBranding={false}
            screenReaderLabel={(
                <FormattedMessage
                    id="base-ui.ErrorModal.errorScreenReader"
                    defaultMessage="Error modal"
                />
            )}
            displayMode={displayMode}
        >
            <ErrorModalDisplay
                title={title}
                description={description}
                acceptText={acceptText}
                onAccept={onAccept}
            />
        </FullScreenTakeover>
    );
}

ErrorModal.propTypes = {
    isOpen: PropTypes.bool,

    onClose: PropTypes.func.isRequired,
    onAccept: PropTypes.func.isRequired,

    title: PropTypes.node.isRequired,
    description: MessagePropType,
    acceptText: MessagePropType,

    displayMode: PropTypes.oneOf(
        Object.values(DISPLAY_MODES),
    ),
};

export default ErrorModal;
